var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManual = function SvgManual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4 6.664c0-.2.097-.532.31-.81.204-.27.487-.454.855-.454H15.6v8.089h-4.035c-.441 0-.84.06-1.165.212V6.664Zm-.8.003c0-.2-.097-.534-.31-.813-.205-.27-.488-.454-.856-.454H4.4v8.089h4.034c.441 0 .84.06 1.166.212V6.667ZM9.6 15h.8c0-.266.085-.41.222-.508.163-.115.456-.203.943-.203H16.4V4.6h-4.835c-.676 0-1.175.353-1.492.769-.026.033-.05.067-.073.101a2.31 2.31 0 0 0-.073-.101C9.61 4.953 9.11 4.6 8.434 4.6H3.6v9.689h4.834c.487 0 .78.088.943.203.137.097.223.242.223.508ZM14 8.4h-2v-.8h2v.8Zm-2 1.5h2v-.8h-2v.8Zm1.25 1.5H12v-.8h1.25v.8Z",
    fill: "currentColor"
  })));
};
export default SvgManual;